import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { AlertTwoTone } from "@ant-design/icons";

import "./style/propertyListing.css";
import DataTable from "../../../../Components/DataTable";
import * as propertyActions from "../../../../actionCreators/Property";
import { addEllipsis } from "../../../../utils";

const ALLProperties = ({
  properties,
  getProperties,
  getPropertyData,
  paginationData,
  getSelectedRows,
  getCurrentProperty,
  getRegisteredProperties,
  registeredProperties,
}) => {
  const history = useHistory();
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({ currentPage: 0 });
  const [selectedRows, setSelectedRows] = React.useState([]);

  React.useEffect(() => {
    if (properties.data) {
      setLoading(properties.loading);
      setPagination(properties.pagination);
      paginationData(properties.pagination);

      const propertiesData = properties.data.map((property) => {
        return { ...property, checked: false };
      });

      setData(propertiesData);
    }
  }, [properties]);

  // React.useEffect(() => {
  //   if (registeredProperties.data) {
  //     setLoading(registeredProperties.loading);
  //     setPagination({
  //       ...pagination,
  //       count: parseInt(registeredProperties.data.total),
  //     });
  //     paginationData({ count: parseInt(registeredProperties.data.total) });

  //     const propertiesData = registeredProperties.data?.properties?.map(
  //       (property) => {
  //         return { ...property, checked: false };
  //       }
  //     );
  //     setData(propertiesData);
  //   }
  // }, [registeredProperties]);

  React.useEffect(() => {
    getSelectedRows(selectedRows);
  }, [selectedRows]);

  const handleTablePageChange = (tableChangeData, filters) => {
    const { current, pageSize } = tableChangeData;
    const status = filters.status;

    getProperties({
      page: current - 1,
      pageSize: pageSize,
      type: "existing",
      filter: status,
    });
  };

  const handleCheckboxChange = (row) => (e) => {
    let propertiesData = [...data];
    let rowSelectedData = [...selectedRows];
    let dataFindIndex = propertiesData.findIndex((obj) => obj.id === row.id);
    propertiesData[dataFindIndex]["checked"] = e.target.checked;
    setData(propertiesData);

    if (!e.target.checked) {
      var removeIndex = rowSelectedData
        .map(function (item) {
          return item.id;
        })
        .indexOf(row.property_inspector.id);

      rowSelectedData.splice(removeIndex, 1);

      setSelectedRows(rowSelectedData);
    }

    if (e.target.checked) {
      const inspector = row.property_inspector;
      setSelectedRows([...selectedRows, inspector]);
    }
  };
  const tableColumns = [
    {
      title: "Owner Name",
      dataIndex: "property_owners",
      render: (property_owners) => {
        return addEllipsis(
          property_owners?.map((owner) => owner?.name)?.join(", ")
        );
      },
    },
    {
      title: "Circle",
      align: "center",
      dataIndex: "circle",
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Highway",
      dataIndex: "highway",
      align: "center",
      width: "12%",
      render: (highway) => (highway ? highway?.name : "---"),
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (address, record) =>
        record?.plot_number +
        ", " +
        record?.street_address +
        ", " +
        record?.road_name,
    },
    {
      title: "Tax Inspector",
      align: "center",
      dataIndex: "property_inspector",
      render: (property_inspector) =>
        property_inspector ? property_inspector?.user?.full_name : "---",
    },
    {
      title: "PIN",
      dataIndex: "pin",
      width: "13%",
      align: "center",
      render: (pin) => pin,
    },
    {
      title: "Status",
      width: "10%",
      dataIndex: "status",
      align: "center",
      filters: [
        {
          text: "Awaiting Approval",
          value: "awaitingApproval",
        },
        {
          text: "Objection Submitted",
          value: "objectionSubmitted",
        },
        {
          text: "Objection Sent to TI",
          value: "objectionSentToTI",
        },
        {
          text: "PH9 issued",
          value: "ph9Issued",
        },
        {
          text: "CRF Request Declined",
          value: "crfRequestDeclined",
        },
        {
          text: "Registered",
          value: "registered",
        },
      ],
      render: (status, row) => {
        if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === null &&
          row?.change_requests[0]?.status !== null
        ) {
          return <span>Awaiting Approval</span>;
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "APPROVED"
        ) {
          if (
            row.property_owners?.[0]?.objections?.[0]?.status === "submitted"
          ) {
            return <span>Objection Submitted</span>;
          } else if (
            row.property_owners?.[0]?.objections?.[0]?.status === "sent"
          ) {
            return <span>Objection Sent to TI</span>;
          } else {
            return <span>PH9 issued</span>;
          }
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "REJECTED"
        ) {
          return <span>CRF Request Declined</span>;
        } else if (status !== null) {
          return status.charAt(0).toUpperCase() + status.slice(1);
        }
      },
    },
    {
      title: "Actions",
      width: "10%",
      dataIndex: "status",
      align: "center",
      render: (status, row) => {
        if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === null &&
          row?.change_requests[0]?.status !== null
        ) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForCRF(row);
              }}
            >
              Open CRF
            </span>
          );
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "APPROVED"
        ) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForPh9Form(row);
              }}
            >
              Open PH9
            </span>
          );
        } else if (
          status === "registered" &&
          row?.change_requests[0]?.approval_status === "REJECTED"
        ) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForCRF(row);
              }}
            >
              Open CRF
            </span>
          );
        } else if (status !== null) {
          return (
            <span
              style={{ color: "#2196F3", textDecoration: "underline" }}
              onClick={() => {
                onTableRowClickForPhOneForm(row);
              }}
            >
              Open PH1
            </span>
          );
        }
      },
    },
  ];

  const onTableRowClickForPhOneForm = (data) => {
    // taxCollectionActions.resetTaxCollection()
    // setRowData(data);
    getCurrentProperty(data);
    history.push("/properties/ph1/" + data.id);
  };

  const onTableRowClickForPh9Form = (data) => {
    getCurrentProperty(data);
    history.push("/properties/ph9/" + data.id);
  };
  const onTableRowClickForCRF = (data) => {
    // getCurrentProperty(data);
    getPropertyData(data);
    history.push("/properties/view/" + data.id);
  };
  const onTableRowClick = (data) => {
    getPropertyData(data);
  };

  return (
    <div>
      <DataTable
        rowClassName="table-row-cursor-pointer"
        columns={tableColumns}
        pagination={pagination}
        loading={loading}
        // getSelectedRows={getSelectedRows}
        data={data}
        handleTableValuesChange={handleTablePageChange}
        onRowClick={onTableRowClick}
      />
    </div>
  );
};

const mapStateToProps = ({
  property: { properties, registeredProperties },
}) => ({ properties, registeredProperties });

const mapDispatchToProps = (dispatch) => ({
  getProperties: bindActionCreators(propertyActions.getProperties, dispatch),
  getRegisteredProperties: bindActionCreators(
    propertyActions.getRegisteredProperties,
    dispatch
  ),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
});

ALLProperties.propTypes = {
  properties: PropTypes.object.isRequired,
  getProperties: PropTypes.func.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ALLProperties);
